import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";

const Competition = ({ competitionData }) => {
  const { id, attributes } = competitionData;
  const { title, listImage, startDate, endDate } = attributes || {};
  const base = process.env.PUBLIC_URL || "";
  const apiBase = process.env.REACT_APP_BASE_URL || "";
  const imgUrl = listImage?.data?.attributes?.url;

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <article className="hn-card hn-card-competition">
      <div className="hn-card-thumb hn-card-thumb-competition" style={{ position: "relative" }}>
        <Link to={`${base}/competitions/${id}`} onClick={scrollTop}>
          <img
            src={imgUrl ? `${apiBase}${imgUrl}` : "https://via.placeholder.com/400x250?text=Competition"}
            alt={title}
          />
        </Link>
        <span className="hn-card-badge hn-card-badge-competition">
          <i className="bi bi-trophy-fill" /> Competition
        </span>
      </div>
      <div className="hn-card-body">
        <div className="hn-card-meta">
          <span><i className="bi bi-calendar2-week" /> Starts {moment(startDate).format("DD MMM YYYY")}</span>
          {endDate && (
            <span><i className="bi bi-calendar2-event" /> Ends {moment(endDate).format("DD MMM YYYY")}</span>
          )}
        </div>
        <h3 className="hn-card-title">
          <Link to={`${base}/competitions/${id}`} onClick={scrollTop}>
            {title}
          </Link>
        </h3>
        <Link to={`${base}/competitions/${id}`} className="hn-card-cta" onClick={scrollTop}>
          Enter competition <i className="bi bi-arrow-right" />
        </Link>
      </div>
    </article>
  );
};

export default Competition;
